import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import style from './index.module.scss';

function Comment({ comment: { body, commentedBy: { fullname, id, imgUrl } } }) {
  const { img, reply, vote } = style;

  return (
    <div className={`row ${style['row--comment']}`}>
      <div className={`col-12 ${style['col--user']}`}>
        <Link
          to={{
            pathname: `/account/${fullname}`,
            state: {
              userId: id,
            },
          }}
        >
          <img
            src={imgUrl || "https://i.imgur.com/qHpJwKV.jpg"}
            alt={fullname}
            className={img}
          />
        </Link>
        <div className={`row ${style['row--user']}`}>
          <div className={`col-12`}>
            <Link
              to={{
                pathname: `/account/${fullname}`,
                state: {
                  userId: id,
                },
              }}
              className={style['user-name']}
            >
              {fullname}
            </Link>
          </div>
          <div className={`col-12`}>
            <p>
              May 12, 2018 · 1,343 upvotes including{' '}
              <Link
                to={{
                  pathname: `/account/${'user.fullname'}`,
                  state: {
                    userId: 'user.id',
                  },
                }}
                className={style['user-name']}
              >
                Alexey Tereshchenko
              </Link>
            </p>
          </div>
        </div>
      </div>
      <p className={style['comment-body']}>{body}</p>
      <div className={`col-12 ${style['col--actions']}`}>
        <div className={`row ${style['row--actions']}`}>
          <div className={`col-6 ${style['col--left']}`}>
            <span className={reply}>
              <i className={`fas fa-chevron-down ${style.icon}`} /> Reply
            </span>
            <span className={`${vote} ${style['vote--up']}`}>
              <i className={`fas fa-chevron-up ${style.icon}`} /> Upvote
            </span>
          </div>
          <div className={`col-6 ${style['col--right']}`}>
            <span className={`${vote} ${style['vote--down']}`}>
              <i className={`fas fa-chevron-down ${style.icon}`} /> Downvote
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

Comment.propTypes = {
  comment: PropTypes.shape({
    body: PropTypes.string.isRequired,
    commentedBy: PropTypes.object.isRequired,
  })
}

export default Comment;
